import {
  Address,
  AutoCoveragesModel,
  CoverageChangeModel,
  Policy,
  QuoteModel
} from '@amfam/policy/models';

export class CoverageChangeRequest {
  public autoCoverages?: AutoCoveragesModel;
  public selectedCoverages?: CoverageChangeModel;
  public quote?: QuoteModel;
  public requestType?: 'OnlineBind' | 'SendToAgent';
}

export class InitialCoverageChangeRequestState {
  public autoCoverages = null;
  public selectedCoverages = null;
  public quote = null;
}

export interface ChangeCoverageAnalyticsModel {
  pageAnalyticName?: string;
  buttonAnalyticName?: string;
  eventName?: string;
  selection?: string[];
  rraAmount?: string;
}
